<template>
  <header :class="$options.name">
    <nav>
      <router-link
        class="Logo__wrap"
        to="/"
        active-class="Logo__wrap--active"
        exact-active-class="Logo__wrap--active"
        aria-label="Return home"
      >
        <Logo :size="48"/>
      </router-link>
      <router-link to="/builds" active-class="active" exact-active-class="active" aria-label="View bike builds">
        <span>Builds</span>
      </router-link>
      <router-link to="/about" active-class="active" exact-active-class="active" aria-label="Learn more about Nice Bike">
        <span>About Us</span>
      </router-link>
      <router-link to="/news" active-class="active" exact-active-class="active" aria-label="Read latest news">
        <span>News</span>
      </router-link>
      <router-link to="/contact" active-class="active" exact-active-class="active" aria-label="Get in touch and say hello">
        <span>Contact</span>
      </router-link>
    </nav>
  </header>
</template>
<script>
import Logo from "@/components/Logo";
export default {
  name: "Header",
  components: { Logo }
};
</script>
<style lang="scss">
.Header {
  background-color: var(--contrast);
  border-bottom: rem(1) solid var(--base-ghost);
  display: flex;
  height: rem(96);
  justify-content: center;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  @include breakpoint(xsl) {
    height: rem(64);
  }
  nav {
    align-items: stretch;
    display: flex;
    flex-grow: 1;
    flex-wrap: wrap;
    max-width: rem(960);
    a {
      @include typeSize(s, m);
      align-items: center;
      display: inline-flex;
      font-weight: 500;
      flex-grow: 1;
      font-weight: 500;
      justify-content: center;
      min-height: rem(40);
      &:focus,
      &:hover {
        color: var(--base-mid);
      }
      &.Logo__wrap {
        flex-basis: 100%;
        margin-top: rem(8);
        min-height: rem(48);
        @include breakpoint(xsl) {
          flex-basis: auto;
          justify-content: flex-start;
          margin-top: 0;
          min-height: rem(64);
        }
      }
      span {
        display: inline-block;
        position: relative;
        &:after {
          @include smooth;
          background-color: var(--highlight);
          content: "";
          bottom: rem(-8);
          height: rem(4);
          left: 0;
          opacity: 0;
          position: absolute;
          width: 100%;
          @include breakpoint(xsl) {
            bottom: rem(-20);
          }
        }
      }
      &.active span:after {
        opacity: 1;
      }
    }
  }
}
</style>